import React, { FC } from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

import WistiaWithPreview from "@components/WistiaWithPreview/WistiaWithPreview"

import {
  PostImageDIV,
  PostImageFrameDIV,
} from "./PostImage.styles"
import { PostTemplatePostFragmentFragment } from "@graphqlTypes"

const GatsbyImageNoFade = styled(GatsbyImage)`
  img {
    opacity: 1 !important;
  }
`

type PostHeroImageProps = {
  image: PostTemplatePostFragmentFragment["image"],
  imageArtist: PostTemplatePostFragmentFragment["imageArtist"],
  imageAltText: string,
  imageBackgroundColor: PostTemplatePostFragmentFragment["imageBackgroundColor"],
  useExtendedImage: PostTemplatePostFragmentFragment["useExtendedImage"],
  wistiaId: PostTemplatePostFragmentFragment["wistiaId"],
  wistiaPreviewImg: PostTemplatePostFragmentFragment["wistiaPreviewImage"]
}

const PostHeroImage: FC<PostHeroImageProps> = ({
  image,
  imageArtist,
  imageAltText,
  imageBackgroundColor,
  useExtendedImage,
  wistiaId,
  wistiaPreviewImg,
}) => (
  <>
    <PostImageDIV
      className={`PostImage ${useExtendedImage ? "use-extended-image" : ""}`}
    >
      {wistiaId ? (
        <WistiaWithPreview id={wistiaId} previewImageData={wistiaPreviewImg} />
      ) : (
        <PostImageFrameDIV style={{ background: `${imageBackgroundColor}` }}>
          <GatsbyImageNoFade
            image={image}
            loading="eager"
            placeholder="none"
            alt={imageAltText}
          />
        </PostImageFrameDIV>
      )}
      {imageArtist && <cite>Illustration by {imageArtist}</cite>}
    </PostImageDIV>
  </>
)

export default PostHeroImage
